module.exports = require("/opt/build/repo/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 390
// module chunks = 231608221292675